export default "__VITE_ASSET__b3e7d136__"